import { Component, OnInit } from '@angular/core';
import { CustomApplicationCreator } from './custom-application-creation.service';
import { ApiResponse } from '../../models/api-response';
import { NotificationService } from "../../services/notification.service";

@Component({
    selector: 'custom-application-creation',
    template: require('./custom-application-creation.component.html')
})
export class CustomApplicationCreatorComponent {
    applicationName: string;
    userEmail: string = "";
    loginUrl: string = "";
    redirectUrl: string = "";
    replyUrl: string = "";
    entityType:string='ActiveDirectory';
    
    invalidApplicationName: boolean = false;
    invalidEmail: boolean = false;
    invalidLoginUrl: boolean = false;
    invalidRedirectUrl: boolean = false;
    invalidReplyUrl:boolean=false;
    confirmationDialog: boolean = false;
    isCustomForgeRockApplicationCreated: boolean = false;
    isCustomAdApplicationCreated:boolean=false;

    customAppCreationResult: any;
    customAdAppCreationResult: any;

    responseData: any;

    applicationNameValidator = /^[a-zA-Z0-9_]+$/;
    emailValidator = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    urlValidator = /^https:\/\/(www\.)?[a-zA-Z0-9_]+([\-\.]{1}[a-zA-Z0-9]+)*((\.[a-zA-Z]{2,5})|(\.[0-9]{1,3}))(:[0-9]{1,5})?(\/.*)?$/;

    constructor(private customApplicationCreator: CustomApplicationCreator,
        private notifier: NotificationService) {
        this.notifier.clear();
    }

    clearMessages() {
        this.isCustomForgeRockApplicationCreated = false;
        this.isCustomAdApplicationCreated = false;
        this.notifier.clear();
    }

    validateInputs() {
        this.clearMessages();
        if (this.applicationName == null || this.applicationName.trim() === '') {
            this.notifier.displayError("Please enter the application name");
            this.invalidApplicationName = true;
            this.confirmationDialog = false;
            return;
        }
        if (this.isValidApplicationName(this.applicationName.trim()) === false) {
            this.notifier.displayError("Please enter a valid application name");
            this.invalidApplicationName = true;
            this.confirmationDialog = false;
            return;
        }
        this.invalidApplicationName = false;
        if (this.userEmail !== '') {
            if (this.isValidEmail(this.userEmail) === false) {
                this.notifier.displayError("Please enter a valid email Id");
                this.invalidEmail = true;
                this.confirmationDialog = false;
                return;
            }
        }
        this.invalidEmail = false;
        if (this.loginUrl !== '') {
            if (this.isValidUrl(this.loginUrl) === false) {
                this.notifier.displayError("Please enter a valid Url");
                this.invalidLoginUrl = true;
                this.confirmationDialog = false;
                return;
            }
        }
        this.invalidLoginUrl = false;
        if (this.redirectUrl !== '') {
            if (this.isValidUrl(this.redirectUrl) === false) {
                this.notifier.displayError("Please enter a valid Url");
                this.invalidRedirectUrl = true;
                this.confirmationDialog = false;
                return;
            }
        }
        this.invalidReplyUrl = false;
        if (this.replyUrl !== '') {
            if (this.isValidUrl(this.replyUrl) === false) {
                this.notifier.displayError("Please enter a valid Url");
                this.invalidReplyUrl = true;
                this.confirmationDialog = false;
                return;
            }
        }
        this.invalidReplyUrl = false;
        this.confirmationDialog = true;
    }

    createCustomApplication() {
        this.clearMessages();
        this.notifier.displayInfo("Creating the application ...");
        if (this.entityType === 'ActiveDirectory') {
            this.customApplicationCreator.createCustomAdApplication(this.applicationName, this.userEmail, this.replyUrl)
                .subscribe(
                    resp => {
                        this.notifier.clear();
                        this.responseData = resp;
                        this.processCustomApplicationCreationResponse(this.responseData);
                    },
                    error => {
                        this.isCustomAdApplicationCreated = false;
                        this.notifier.displayApiResponseError(error);
                    }
                );
        } else {
            this.customApplicationCreator
                .createCustomApplication(this.applicationName, this.userEmail, this.loginUrl, this.redirectUrl)
                .subscribe(
                    resp => {
                        this.notifier.clear();
                        this.responseData = resp;
                        this.processCustomApplicationCreationResponse(this.responseData);
                    },
                    error => {
                        this.isCustomForgeRockApplicationCreated = false;
                        this.notifier.displayApiResponseError(error);
                    }
                );
        }
    }

    isValidApplicationName(applicationName) {
        return this.applicationNameValidator.test(applicationName);
    }

    isValidEmail(email) {
        return this.emailValidator.test(email);
    }

    isValidUrl(url) {
        return this.urlValidator.test(url);
    }

    processCustomApplicationCreationResponse(responseData) {
        if (responseData.statusCode === 200) {
            if (this.entityType === 'ForgeRock') {
                if (responseData.data.isApplicationAlreadyExisting) {
                    this.notifier.displayInfo("Application already exists");
                } else {
                    this.notifier.displaySuccess("Application created successfully");
                }
                this.customAppCreationResult = responseData.data.applicationCreationResult;
                this.isCustomForgeRockApplicationCreated = true;
            } else {
                this.notifier.displaySuccess("Application created successfully");
                this.customAdAppCreationResult = responseData.data;
                this.isCustomAdApplicationCreated = true;
            }
        } else {
            this.notifier.displayError(responseData.data.value);
            this.isCustomForgeRockApplicationCreated = false;
            this.isCustomAdApplicationCreated = false;
        }
    }
    initializeCurrentTab(entity:string) {
        this.notifier.clear();
        this.entityType = entity;
        this.isCustomForgeRockApplicationCreated = false;
        this.isCustomAdApplicationCreated = false;
    }
    
    
}


/** WEBPACK FOOTER **
 ** ./F:/actions-runner/_work/scpbuildinig_sentience.portal.devops/scpbuildinig_sentience.portal.devops/src/Production/Portal/Cloud.Platform.Global.Portal.DevOps.Web/app/main/customapplicationcreation/custom-application-creation.component.ts
 **/